import type {AllowedNonCommentReviewType} from '../../page-data/payloads/toolbar'

export type ReviewMode = 'comments' | 'review'

export function getAllowedReviewMode({
  viewerIsAuthor,
  viewerAllowedNonCommentReviewTypes,
  isPROpen,
}: {
  viewerIsAuthor: boolean
  viewerAllowedNonCommentReviewTypes: AllowedNonCommentReviewType[]
  isPROpen: boolean
}): ReviewMode {
  const viewerCanApprove = viewerAllowedNonCommentReviewTypes.includes('APPROVE')
  const viewerCanRequestChanges = viewerAllowedNonCommentReviewTypes.includes('REQUEST_CHANGES')

  switch (true) {
    case !isPROpen:
      return 'comments'
    case viewerIsAuthor:
    case viewerCanApprove:
    case viewerCanRequestChanges:
      return 'review'
    default:
      return 'comments'
  }
}
